// Queue Status Component for monitoring request queue
import React, { useState, useEffect } from 'react';
import { Activity, AlertCircle, CheckCircle, Clock, Zap } from 'lucide-react';
import { getQueueStatus, clearQueue } from '../../utils/supabaseQueue';

export default function QueueStatus({ isVisible = false }) {
  const [status, setStatus] = useState({
    queueLength: 0,
    activeRequests: 0,
    circuitBreakerOpen: false,
    circuitBreakerFailures: 0
  });

  useEffect(() => {
    if (!isVisible) return;

    const updateStatus = () => {
      setStatus(getQueueStatus());
    };

    // Update immediately
    updateStatus();

    // Update every second while visible
    const interval = setInterval(updateStatus, 1000);

    return () => clearInterval(interval);
  }, [isVisible]);

  if (!isVisible) return null;

  const getStatusColor = () => {
    if (status.circuitBreakerOpen) return 'text-red-400';
    if (status.queueLength > 10) return 'text-yellow-400';
    if (status.activeRequests > 0) return 'text-blue-400';
    return 'text-green-400';
  };

  const getStatusIcon = () => {
    if (status.circuitBreakerOpen) return <AlertCircle size={16} />;
    if (status.queueLength > 0 || status.activeRequests > 0) return <Clock size={16} />;
    return <CheckCircle size={16} />;
  };

  const getStatusText = () => {
    if (status.circuitBreakerOpen) return 'Circuit Breaker Open';
    if (status.queueLength > 0) return `${status.queueLength} Queued`;
    if (status.activeRequests > 0) return `${status.activeRequests} Active`;
    return 'All Clear';
  };

  return (
    <div className="fixed bottom-4 right-4 bg-gray-800 border border-gray-600 rounded-lg p-3 shadow-lg z-50">
      <div className="flex items-center gap-2 mb-2">
        <Activity className="text-orange-400" size={16} />
        <span className="text-orange-300 font-semibold text-sm">Request Queue</span>
      </div>
      
      <div className="space-y-1 text-xs">
        <div className={`flex items-center gap-2 ${getStatusColor()}`}>
          {getStatusIcon()}
          <span>{getStatusText()}</span>
        </div>
        
        <div className="text-gray-400">
          <div>Queue: {status.queueLength}</div>
          <div>Active: {status.activeRequests}</div>
          {status.circuitBreakerFailures > 0 && (
            <div className="text-red-400">
              Failures: {status.circuitBreakerFailures}
            </div>
          )}
        </div>
        
        {status.circuitBreakerOpen && (
          <div className="text-red-300 text-xs mt-1">
            <Zap size={12} className="inline mr-1" />
            Requests paused due to errors
          </div>
        )}
        
        {(status.queueLength > 0 || status.circuitBreakerFailures > 0) && (
          <button
            onClick={() => {
              clearQueue();
              setStatus(getQueueStatus());
            }}
            className="mt-2 bg-red-600 hover:bg-red-500 text-white px-2 py-1 rounded text-xs"
          >
            Clear Queue
          </button>
        )}
      </div>
    </div>
  );
}













